export default "__VITE_ASSET__DXIairyZ__"